var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4ElectricalDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 58.78A6.09 6.09 0 0060 54h-9.46v-.08c0-.09.08-.19.11-.28a13.36 13.36 0 00-10.3-17.42H40V27h14L46.28 8H29.72L22 27h14v9.17h-.35a13.36 13.36 0 00-8.52 21l.6.83h32.2A2.11 2.11 0 0162 59.57a2.06 2.06 0 01-.41 1.7 2 2 0 01-1.55.73H24.35A7.51 7.51 0 0017 56h-2v3h-5v3h5v3h-5v3h5v3h2a7.49 7.49 0 007.06-5h36A6 6 0 0066 58.78zm-19.15-6.34l-.06.17c-.176.48-.39.944-.64 1.39h-16.3a9.23 9.23 0 01-1.23-4.62A9.34 9.34 0 0136 40.24l.35-.08h.17a8.182 8.182 0 013 0h.18l.34.07a9.32 9.32 0 016.85 12.21h-.04z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Electrical_devices.c09ac030.svg";
export { SvgA4ElectricalDevices as ReactComponent };